import { ddClg } from '@didi/wsgsdk'

ddClg({
  omega: window.Omega,
  domainList: [
    'act-api.didi-food.com',
    'c.didi-food.com',
  ]
})
